
import ForgetPasswordComp from './components/ForgetPasswordComp.vue';
import LoginFormComp from './components/LoginFormComp.vue';
import RegisterFormComp from './components/RegisterFormComp.vue';
import OverlayContentComp from './components/OverlayContentComp.vue';

import { Component, Ref, Vue } from 'vue-property-decorator';
import { Form as ElForm } from 'element-ui';
import { getPhoneRegionApi } from '@/api/login';
import { getGear3BaseUrl } from '@/utils/function_utils';
import {redirectToGear3Login} from '@/utils/function_utils';

const LOGIN_UPGRADE_NOTICE_KEY = 'login-upgrade-notice-issue';
const LOGIN_UPGRADE_DEFAULT_URL = 'https://gear-ai.geteducation.net';
const LOGIN_UPGRADE_COUNTDOWN = 10;

@Component({
  name: 'login',
  components: {
    LoginFormComp,
    RegisterFormComp,
    OverlayContentComp,
    ForgetPasswordComp,
  },
})
export default class extends Vue {
  @Ref('login-form') public loginForm!: ElForm;
  @Ref('register-form') public registerForm!: ElForm;
  public exflag = false; // 登录注册之间切换标记
  public dialogVisible = false;
  public phoneRegionOptions: any = [];
  public countryOptions: any = [];
  public upgradeNoticeVisible = false;
  public upgradeNoticeCountdown = LOGIN_UPGRADE_COUNTDOWN;
  public upgradeNoticeTimer: number | null = null;
  public redirecting = false;

  public mounted() {
    const query = this.$route.query;
    if (query && query.invitcode) {
      this.handleSignUp();
    }
    this.getPhoneRegion();
    this.showUpgradeNotice();
  }

  public beforeDestroy() {
    this.clearUpgradeNoticeTimer();
  }

  public showUpgradeNotice() {
    const query: any = this.$route.query;
    // 直接转跳逻辑
    if(query.testData!=='1'||!query){
      redirectToGear3Login('');
    }
    // 弹窗转跳逻辑
    // if (this.hasShownUpgradeNotice()) {
    //   return;
    // }
    // this.markUpgradeNoticeShown();
    // this.upgradeNoticeVisible = true;
    // this.upgradeNoticeCountdown = LOGIN_UPGRADE_COUNTDOWN;
    // this.redirecting = false;
    // this.startUpgradeNoticeTimer();
  }

  public hasShownUpgradeNotice() {
    try {
      return window.sessionStorage.getItem(LOGIN_UPGRADE_NOTICE_KEY) === '1';
    } catch (err) {
      return false;
    }
  }

  public markUpgradeNoticeShown() {
    try {
      window.sessionStorage.setItem(LOGIN_UPGRADE_NOTICE_KEY, '1');
    } catch (err) {
      // ignore storage errors and still show the dialog
    }
  }

  public startUpgradeNoticeTimer() {
    this.clearUpgradeNoticeTimer();
    this.upgradeNoticeTimer = window.setInterval(() => {
      if (this.upgradeNoticeCountdown <= 1) {
        this.handleRedirectToNewPlatform();
        return;
      }
      this.upgradeNoticeCountdown -= 1;
    }, 1000);
  }

  public clearUpgradeNoticeTimer() {
    if (this.upgradeNoticeTimer !== null) {
      window.clearInterval(this.upgradeNoticeTimer);
      this.upgradeNoticeTimer = null;
    }
  }

  public handleContinueLogin() {
    this.clearUpgradeNoticeTimer();
    this.redirecting = false;
    this.upgradeNoticeVisible = false;
  }

  public handleRedirectToNewPlatform() {
    this.clearUpgradeNoticeTimer();
    this.redirecting = true;
    this.upgradeNoticeVisible = false;
    window.location.replace(getGear3BaseUrl() || LOGIN_UPGRADE_DEFAULT_URL);
  }

  public handleSignIn() {
    this.exflag = false;
    if (this.registerForm) {
      this.registerForm.clearValidate();
    }
  }

  public handleSignUp() {
    this.exflag = true;
    if (this.loginForm) {
      this.loginForm.clearValidate();
    }
  }

  public handleModifyPwd() {
    this.dialogVisible = true;
  }

  public registerToLogin() {
    this.exflag = false;
  }

  // 获取手机区号
  public async getPhoneRegion() {
    const { data } = await getPhoneRegionApi();
    this.phoneRegionOptions = data.datas;
  }

  public getCountryOptions(datas: any) {
    this.countryOptions = datas || [];
  }
}
